(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function parseVariantMedia() {
    var dataElement = document.querySelector('[data-mp-innotec-variants]');
    if (!dataElement) return [];

    try {
      var parsed = JSON.parse(dataElement.textContent);
      return Array.isArray(parsed.variants) ? parsed.variants : [];
    } catch (error) {
      return [];
    }
  }

  function getPackQuantity(title) {
    var normalized = String(title || '').toLowerCase();
    var match = normalized.match(/(^|\D)(\d+)\s*(?:er|x|stück|st\b)/);

    if (match) return parseInt(match[2], 10);
    if (normalized.indexOf('einzel') !== -1) return 1;

    return null;
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) {
      return variant.options.map(function (option) {
        return String(option);
      });
    }

    return String(variant.title || '').split(' / ');
  }

  function setupPackSavings(root, variants) {
    var optionControls = Array.prototype.slice
      .call(root.querySelectorAll('[data-product-option]'))
      .filter(function (control) {
        return (
          control.matches('.option-value-input') ||
          control.matches('select.form-field-select')
        );
      });

    var controlsByOption = {};

    optionControls.forEach(function (control) {
      var optionIndex = String(control.getAttribute('data-product-option'));
      if (!controlsByOption[optionIndex]) controlsByOption[optionIndex] = [];
      controlsByOption[optionIndex].push(control);
    });

    var packOptionIndex = Object.keys(controlsByOption).find(function (optionIndex) {
      var quantities = controlsByOption[optionIndex].map(function (control) {
        return getPackQuantity(control.value);
      });

      return (
        quantities.indexOf(1) !== -1 &&
        quantities.some(function (quantity) {
          return quantity > 1;
        })
      );
    });

    if (typeof packOptionIndex === 'undefined') return;

    packOptionIndex = Number(packOptionIndex);

    var pricedVariants = variants
      .map(function (variant) {
        return {
          id: String(variant.id || ''),
          options: getVariantOptions(variant),
          price: Number(variant.price)
        };
      })
      .filter(function (variant) {
        return variant.options.length > packOptionIndex && variant.price > 0;
      });

    function getSelectedOptions() {
      var selectedOptions = {};

      optionControls.forEach(function (control) {
        var optionIndex = Number(control.getAttribute('data-product-option'));
        var isSelect = control.tagName === 'SELECT';

        if (isSelect || control.checked) {
          selectedOptions[optionIndex] = String(control.value || '');
        }
      });

      return selectedOptions;
    }

    function matchesCurrentExecution(variant, selectedOptions, packValue) {
      return variant.options.every(function (optionValue, optionIndex) {
        if (optionIndex === packOptionIndex) {
          return String(optionValue) === String(packValue);
        }

        return (
          typeof selectedOptions[optionIndex] === 'undefined' ||
          String(optionValue) === String(selectedOptions[optionIndex])
        );
      });
    }

    function findSingleVariant(selectedOptions) {
      return pricedVariants.find(function (variant) {
        return variant.options.every(function (optionValue, optionIndex) {
          if (optionIndex === packOptionIndex) {
            return getPackQuantity(optionValue) === 1;
          }

          return (
            typeof selectedOptions[optionIndex] === 'undefined' ||
            String(optionValue) === String(selectedOptions[optionIndex])
          );
        });
      });
    }

    function resetSavingLabel(input) {
      var name = input.parentElement.querySelector('.option-value-name');
      var savingLabel = name && name.querySelector('.mp-innotec-set-saving');

      if (savingLabel) savingLabel.remove();

      if (!input.hasAttribute('data-mp-innotec-base-aria')) {
        input.setAttribute(
          'data-mp-innotec-base-aria',
          input.getAttribute('aria-label') || String(input.value || '')
        );
      }

      input.setAttribute(
        'aria-label',
        input.getAttribute('data-mp-innotec-base-aria')
      );
    }

    function addSavingPlaceholder(input) {
      var name = input.parentElement.querySelector('.option-value-name');
      if (!name) return;

      var placeholder = document.createElement('span');
      placeholder.className =
        'mp-innotec-set-saving mp-innotec-set-saving--placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.textContent = '\u00a0';
      name.appendChild(placeholder);
    }

    function updatePackSavings() {
      var selectedOptions = getSelectedOptions();
      var singleVariant = findSingleVariant(selectedOptions);
      var packInputs = controlsByOption[String(packOptionIndex)].filter(function (control) {
        return control.matches('.option-value-input');
      });

      packInputs.forEach(resetSavingLabel);
      packInputs.forEach(addSavingPlaceholder);

      if (!singleVariant) return;

      packInputs.forEach(function (input) {
        var value = String(input.value || '');
        var quantity = getPackQuantity(value);

        if (!quantity || quantity <= 1) return;

        var packVariant = pricedVariants.find(function (variant) {
          return matchesCurrentExecution(variant, selectedOptions, value);
        });

        if (!packVariant) return;

        var regularPrice = singleVariant.price * quantity;
        var saving = Math.round((1 - packVariant.price / regularPrice) * 100);
        if (saving < 1) return;

        var name = input.parentElement.querySelector('.option-value-name');
        if (!name) return;

        var savingLabel = name.querySelector('.mp-innotec-set-saving');
        if (!savingLabel) {
          savingLabel = document.createElement('span');
          name.appendChild(savingLabel);
        }

        savingLabel.className = 'mp-innotec-set-saving';
        savingLabel.removeAttribute('aria-hidden');
        savingLabel.textContent = saving + ' % Set-Vorteil';
        input.setAttribute(
          'aria-label',
          value + ', ' + saving + ' Prozent Set-Vorteil'
        );
      });
    }

    updatePackSavings();

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-product-option], [data-variants]')) return;
      window.setTimeout(updatePackSavings, 0);
    });

    if (window.jQuery) {
      window.jQuery(window).on(
        'shopify-variants:switch-variant.mpInnotecSavings',
        function () {
          window.setTimeout(updatePackSavings, 0);
        }
      );
    }
  }

  function setupVariantGallery(root) {
    var variants = parseVariantMedia();
    var gallery = root.querySelector('[data-product-gallery]');
    var variantSelect = root.querySelector('[data-variants]');

    if (!gallery || !variantSelect || !variants.length) return;

    var mediaByVariant = {};
    var variantMediaIds = {};

    variants.forEach(function (variant) {
      if (variant.mediaId === null || typeof variant.mediaId === 'undefined') return;
      mediaByVariant[String(variant.id)] = String(variant.mediaId);
      variantMediaIds[String(variant.mediaId)] = true;
    });

    function isVariantSpecificMedia(element, mediaId) {
      if (variantMediaIds[mediaId]) return true;

      var mediaAlt = String(element.getAttribute('data-media-alt') || '');
      return /artikelnummer/i.test(mediaAlt);
    }

    function updateVisibleThumbnails(variantId) {
      var activeMediaId = mediaByVariant[String(variantId || variantSelect.value)] || '';
      var thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

      thumbnails.forEach(function (thumbnail) {
        var mediaId = String(thumbnail.getAttribute('data-media') || '');
        var belongsToAnotherVariant =
          isVariantSpecificMedia(thumbnail, mediaId) && mediaId !== activeMediaId;

        thumbnail.hidden = belongsToAnotherVariant;
        thumbnail.setAttribute('aria-hidden', belongsToAnotherVariant ? 'true' : 'false');

        if (belongsToAnotherVariant) {
          thumbnail.setAttribute('tabindex', '-1');
        } else {
          thumbnail.removeAttribute('tabindex');
        }
      });
    }

    updateVisibleThumbnails(variantSelect.value);

    document.addEventListener('change', function (event) {
      if (!root.contains(event.target)) return;
      if (!event.target.matches('[data-product-option], [data-variants]')) return;

      window.setTimeout(function () {
        updateVisibleThumbnails(variantSelect.value);
      }, 0);
    });

    if (window.jQuery) {
      window.jQuery(window).on('shopify-variants:switch-variant.mpInnotec', function (event, data) {
        if (!data || !data.variant) return;
        window.setTimeout(function () {
          updateVisibleThumbnails(data.variant.id);
        }, 0);
      });
    }
  }

  function setupRecommendationGuard() {
    var container = document.querySelector(
      '#shopify-section-static-product-recommendations [data-product-recommendations]'
    );

    var fallback = document.querySelector('[data-mp-innotec-fallback-recommendations]');

    if (!container) {
      if (fallback) fallback.hidden = false;
      return;
    }

    var section = container.closest('.shopify-section') || container.parentElement;

    function normalizeRecommendations() {
      var rawText = (container.textContent || '').trim();
      var hasProducts = !!container.querySelector('[data-product-row] [data-product-item]');
      var invalidResponse =
        rawText === '[object Object]' ||
        rawText === 'object Object' ||
        rawText.indexOf('[object Object]') !== -1;

      if (invalidResponse) {
        container.innerHTML = '';
        rawText = '';
        hasProducts = false;
      }

      if (hasProducts) {
        section.classList.remove('mp-recommendations-empty');
        if (fallback) fallback.hidden = true;
      } else {
        section.classList.add('mp-recommendations-empty');
        if (fallback) fallback.hidden = false;
      }
    }

    normalizeRecommendations();

    var observer = new MutationObserver(normalizeRecommendations);
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  onReady(function () {
    var root = document.querySelector('[data-mp-innotec-product]');
    if (!root) return;

    document.body.classList.add('mp-innotec-page');

    var variants = parseVariantMedia();
    setupVariantGallery(root);
    setupPackSavings(root, variants);
    setupRecommendationGuard();
  });
})();
